<template>
  <div>
    <Bar>项目信息</Bar>
    <div class="e-flex jc-center" style="text-align: left">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        style="width: 600px"
        label-width="150px"
      >
        <ProjectInfoFields
          ref="projectInfoFields"
          :form="form"
          :show-project-source="isShowProjectSource()"
          :show-xt="true"
          :is-cqsw="isCqsw"
          :is-hlj="isHlj"
          :is-shgz="isShgz()"
          :is-bsgzw="isBsgzw"
          @source-change="onSourceChange"
          @self-fill-confirm="onSelfFillConfirm"
          @project-info-selected="onProjectInfoSelected"
        />
        <el-form-item label="项目地区" prop="rojectArea">
          <el-cascader
            v-model="form.rojectArea"
            :options="options"
            @change="cascaderHandleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="标段ID" prop="packageId" v-show="false">
          <el-input v-model="form.packageId" />
        </el-form-item>
        <el-form-item label="开标日期" prop="openingDate">
          <el-date-picker
            :picker-options="{
              disabledDate: disabledDate,
            }"
            placeholder="请选择开标日期"
            type="datetime"
            v-model="form.openingDate"
          />
        </el-form-item>
        <el-form-item label="投标有效期（天）" prop="validityPeriod">
          <el-input
            v-model="form.validityPeriod"
            placeholder="请填写投标有效期"
          />
        </el-form-item>
        <el-form-item label="招标人名称" prop="tenderCompanyName">
          <el-input
            v-model="form.tenderCompanyName"
            placeholder="请填写招标人名称"
            :disabled = "isShgz() || isHlj"
          />
        </el-form-item>
        <el-form-item label="招标人地址" prop="tenderAddress">
          <el-input
            v-model="form.tenderAddress"
            placeholder="请填写招标人地址"
          />
        </el-form-item>
        <el-form-item v-if="apiType === '0'" label="代理机构名称" prop="agentName">
          <el-input
            v-model="form.agentName"
            placeholder="请填写代理机构名称"
          />
        </el-form-item>

        <el-form-item label="上传招标文件" prop="tenderFileId">
          <UP
            actionUrl="/zcjf/base/file/upload"
            uploadTitle="上传招标文件"
            @fileIdCb="uploadSuccess"
             accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
            :fileId="form.tenderFileId"
            :filetypes = "['pdf','doc','docx','rar','zip','jpg','bmp','gif','png','jpeg']"

          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <li>支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</li>
              </ul>
            </template></UP>
        </el-form-item>
        <el-form-item>
          <el-button @click="gopage"> 上一步 </el-button>
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="onSubmit"> 下一步 </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import uploadE from '../../../common/upload/uoload.vue'
import { data } from '../../../util/cityData'
import { mapMutations, mapState, LETTER } from '../../../store/modules/letter'
import { cloneDeep } from 'lodash'
import { queryHbOrderInfo, queryApiConfigInfo } from '../../../api/comm'
import { renderArea } from '@/shared/location'
import bar from '../projectBar/bar'
import dayjs from 'dayjs'
import ProjectInfoFields from '../projectInfoFields.vue'
import { ORDER_TYPE, saveCurrentDraft } from '@/shared/guaranteeDraft'

export default {
  data() {
    let FileIdpass = (rule, value, callback) => {
      if (this.form.tenderFileId) {
        callback()
      } else {
        return callback(new Error('请填写必填项目'))
      }
    }
    const validityPeriod = (rule, value, callback) => {
      if (
        /^\d+$/.test(this.form.validityPeriod) &&
        this.form.validityPeriod > 0
      ) {
        callback()
      } else {
        callback(new Error('请填写大于0的正整数'))
      }
    }

    return {
      options: data,
      form: {
        projectSource: '',
        sourceRadio: '',
      },
      rules: {
        projectSource: [
          {
            required: true,
            trigger: 'change',
            message: '请选择项目来源',
          },
        ],
        sourceRadio: [
          {
            trigger: 'change',
            required: false,
          },
        ],
        issuingBank: [
          { required: true, message: '请选择保函出具银行', trigger: 'change' },
        ],
        validityPeriod: [
          {
            required: true,
            trigger: 'change',
            validator: validityPeriod,
          },
        ],
        projectName: [
          { required: true, message: '请填写标段名称', trigger: 'change' },
        ],
        projectArea: [
          { required: true, message: '请选择项目地区', trigger: 'change' },
        ],
        projectCode: [
          { required: true, message: '请填写标段编号', trigger: 'change' },
        ],
        tenderCompanyName: [
          { required: true, message: '请填写招标人全称', trigger: 'change' },
        ],
        tenderAddress: {
          required: true,
          message: '请填写招标人地址',
          trigger: 'change',
        },
        agentName: {
          required: true,
          message: '请填写代理机构名称',
          trigger: 'change',
        },
        openingDate: [
          { required: true, message: '请选择开标时间', trigger: 'change' },
        ],
        creditCode: [
          {
            required: true,
            message: '请填写真实项目名称或标段（包）名称',
            trigger: 'change',
          },
        ],
        contactPerson: [
          {
            required: true,
            message: '请填写招标人全称，非代理机构名称',
            trigger: 'change',
          },
        ],
        tenderFileId: [
          { required: true, message: '请上传招标文件', validator: FileIdpass },
        ],
        rojectArea: {
          required: true,
          validator(r, v, callback) {
            if (v) {
              callback()
            } else {
              callback(new Error('请选择项目地区'))
            }
          },
        },
      },
      apiType: '',
      draftSaving: false,
    }
  },
  computed: {
    ...mapState({
      formStorage: 'guarantee',
    }),
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    },
  },
  beforeMount() {
    // step 切换恢复：从 Vuex letter.guarantee 读（父组件 init(data) 在 nextTick 后覆盖为最新值）
    const { formStorage } = this
    this.form = cloneDeep(formStorage || {})
    if (this.form.openingDate) {
      this.form.openingDate = dayjs(this.form.openingDate).toDate()
    }
    if (this.isCqsw) {
      this.form.isNeedCommitment = false
    }
    this.form.rojectArea = renderArea(this.form)
    const { reapply } = this.$route.query
    this.form.reapply = reapply
    this.queryApiConfigInfo()
    this.$forceUpdate()
  },
  components: {
    Bar: bar,
    UP: uploadE,
    ProjectInfoFields: ProjectInfoFields,
  },
  methods: {
    ...mapMutations({
      guarantee: LETTER.GUARANTEE,
    }),
    init(data) {
      this.form = cloneDeep(data || {})
    },
    isShowProjectSource() {
      return !this.$route.query.outerOrderNo && !this.isCqsw && !this.isHlj && !this.isBsgzw
    },
    disabledDate(cur) {
      return dayjs().isAfter(dayjs(cur).add(1, 'days'))
    },
    querySearch(queryString, cb) {
      queryHbOrderInfo(queryString).then((res) => {
        this.form.packageId = null
        cb(res.data)
      })
    },
    handleSelectProject(v) {
      this.form = {
        ...this.form,
        projectCode: v.packageCode,
        openingDate: new Date(v.bidOpenDate),
        tenderCompanyName: v.tendererName,
        packageId: v.packageId,
      }
    },
    onSourceChange() {
      this.guarantee(this.form)
    },
    cascaderHandleChange(e) {
      const [province, city, district] = [e[0], e[1], e[2]]
      Object.assign(this.form, {
        province: province,
        district: district,
        city: city,
      })
      this.onAreaChange()
    },
    onAreaChange() {
      this.$refs.form.validateField('rojectArea')
    },
    onSelfFillConfirm() {
      this.guarantee(this.form)
    },
    uploadSuccess(res) {
      this.form.tenderFileId = res.url
      this.$refs.form.validateField('tenderFileId')
    },
    gopage() {
      this.guarantee(this.form)
      this.$emit('changeIndex', 0)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.guarantee(this.form)
          this.$emit('changeIndex', 2)
        } else {
          return false
        }
      })
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.ELECTRONIC_9600, 1, this.form)
      } finally {
        this.draftSaving = false
      }
    },
    onProjectInfoSelected() {
      this.guarantee(this.form)
    },
    queryApiConfigInfo() {
      const { apiName, apiId } = this.form
      if (apiName || apiId) {
        queryApiConfigInfo({ apiId, apiName }).then((res) => {
          this.apiType = res.data ? res.data.apiType : '0'
        })
      } else {
        this.apiType = '0'
      }
    },
    isShgz() {
      return (this.form.apiName === '上海国招' || this.form.apiId === 'shgz') ? true : false
    },
  },
}
</script>
